module.exports = __webpack_public_path__ + "img/bg-card.7097f2ac.png";